// extracted by mini-css-extract-plugin
export default {"item":"gNy2j5isU9","informationImageWrapper":"Lzh8xU6Rhw","informationImage":"cYzwmW319n"};